// extracted by mini-css-extract-plugin
export default {"block-chips":"eFp1zR","chips":"WMYbv7"};